import PagedElements from '@/models/paged/pagedelements';
import PrinterModelListViewModel from '@/models/view/printermodellistviewmodel';

export default class PagedPrinterModels extends PagedElements<PrinterModelListViewModel> {
    constructor(init?: Partial<PagedPrinterModels>) {
        super(init);
    }
}
